module.exports = __webpack_public_path__ + "static/media/revrogers.a271b966.svg";